import type { dashboardCanvasRendererProps } from '@/components/dashboard/DashboardCanvas';
import { DashboardMetricCard } from '../../../../dashboard/components/DashboardMetricCard';
import { formatDashboardPreviousPeriod } from '../../../../dashboard/format';
import { networkDashboardTimeline } from '../model';
import type { networkDashboardRuntime } from '../widgetRuntime';
import { NetworkDashboardWidgetType, type NetworkDashboardWidget } from '../widgetModel';

export function NetworkMetricRenderer({
  widget,
  runtime,
}: dashboardCanvasRendererProps<NetworkDashboardWidget, networkDashboardRuntime>) {
  if (widget.type !== NetworkDashboardWidgetType.Metric) return null;
  const timeline = runtime.overview.data
    ? networkDashboardTimeline(runtime.overview.data, runtime.range)
    : [];
  return (
    <DashboardMetricCard
      metric={widget.metric}
      total={runtime.overview.data?.total}
      previous={runtime.overview.data?.totalPrevious}
      comparisonPeriod={formatDashboardPreviousPeriod(
        runtime.range,
        runtime.overview.data?.previousPeriodEnd,
      )}
      timeline={timeline}
      loading={runtime.overview.isLoading}
      error={runtime.overview.isError}
      actions={[]}
    />
  );
}
